<template>
  <div>
    <div v-if="isEmpty" class="text-center">
      No data available
    </div>
    <vue-perfect-scrollbar v-else>
      <div class="chart" :style="{maxHeight: maxHeight}">
        <div class="captions">
          <p v-for="(item, index) in itemsFormatted"
             :key="index"
             v-b-popover.hover.top="getPopoverDisplay(item)">
            {{ item.title }}&nbsp;
          </p>
        </div>

        <div class="bars">
          <p v-for="(item, index) in itemsFormatted"
             :key="index"
             :style="{width: `${item.percentageRelative}%`}"
             v-b-popover.hover.top="getPopoverDisplay(item)">
            &nbsp;
          </p>
        </div>

        <div class="values">
          <p v-for="(item, index) in itemsFormatted" :key="index">
            {{ item.volumeFormatted }}&nbsp;
          </p>
        </div>
      </div>
    </vue-perfect-scrollbar>
  </div>
</template>

<script>
  import VuePerfectScrollbar from 'vue-perfect-scrollbar'
  import orderBy from 'lodash-es/orderBy'
  import { formatVolume } from "@/shared/number-utils"

  export default {
    name: 'bar-chart',

    components: {
      'vue-perfect-scrollbar': VuePerfectScrollbar,
    },

    props: {
      items: {
        type: Array,
        default: () => [],
      },

      maxHeight: {
        type: String,
        default: '120px',
      },
    },

    data () {
      return {
        scrollSettings: {
          maxScrollbarLength: 60,
        },
      };
    },

    methods: {
      formatVolume: formatVolume,

      getPopoverDisplay(item) {
        if(item.volume < 1000) {
          return `${item.title}: ${item.volumeFormatted}`;
        } else {
          return `${item.title}: ${item.percentageAbs}% (${item.volumeFormatted})`;
        }
      },
    },

    computed: {
      values() {
        return this.items.map(item => item.volume);
      },

      itemsFormatted() {
        const maxValue = Math.max(...this.values);
        const totalValue = this.values.reduce((a, b) => a + b, 0);

        let items = this.items.map(item => ({
          volume: item.volume,
          volumeFormatted: this.formatVolume(item.volume),
          title: item.title,
          percentageRelative: Math.round((item.volume / maxValue) * 100),
          percentageAbs: Math.round(item.volume * 100 / totalValue),
        }));

        return orderBy(items, ['volume', 'title'], ['desc', 'asc']);
      },

      isEmpty() {
        return !this.values.length;
      },
    },
  }
</script>

<style scoped lang="scss">
  .chart {
    display: flex;
    justify-content: space-between;
    font-size: 12px;

    p {
      // common styles for all 3 section items: captions, bars, values
      min-height: 15px;
      line-height: 15px;
      margin: 0 0 10px 0;
      box-sizing: border-box;
    }

    .captions {
      width: 20%;
      margin-right: 5px;
      p {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
    }

    .bars {
      width: 60%;
      p {
        background-color: #2E93fA;
      }
    }

    .values {
      margin-left: 3px;
      text-align: right;
      white-space: nowrap;
    }
  }
</style>
